<!-- <router-outlet></router-outlet> -->
<div class="frame">
    <ng-container *ngIf="isLoggedIn">
        <app-top-bar (showMenu)="showMenu = true"></app-top-bar>
        <app-side-menu (closeMenu)="showMenu = false" [isShowMenu]="showMenu"></app-side-menu>
    </ng-container>
    <div class="container">
        <router-outlet></router-outlet>
    </div>
</div>